var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroOcto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_4603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62134 20.0551L13.0375 35L28.6761 26.9521L9.62134 20.0551Z",
    fill: "#6D84DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7855 7.66382L9.62134 20.055L28.6761 26.9521L25.7855 7.66382Z",
    fill: "#82A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78149 3.57654L9.62126 20.055L25.7854 7.66383L7.78149 3.57654Z",
    fill: "#65AED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7854 0V7.66384L7.78149 3.57655L25.7854 0Z",
    fill: "#64CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0273438 20.6938L9.62126 20.055L7.7815 3.57654L0.0273438 20.6938Z",
    fill: "#64CFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0412 32.3183L28.676 26.9521L13.0374 35L31.0412 32.3183Z",
    fill: "#3F2D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0374 35L0.0273438 20.6938L9.62126 20.0551L13.0374 35Z",
    fill: "#82A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7854 7.66382L38.4004 15.0729L28.6761 26.9521L25.7854 7.66382Z",
    fill: "#6D84DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7854 0V7.66384L38.4004 15.073L25.7854 0Z",
    fill: "#82A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.676 26.9522L31.0412 32.3183L38.4003 15.073L28.676 26.9522Z",
    fill: "#3C297B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_4603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.373,
    height: 35,
    fill: "white",
    transform: "translate(0.0273438)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroOcto);
export default __webpack_public_path__ + "static/media/hero-octo.f7c5da633156d5542e3a02d85caeeda6.svg";
export { ForwardRef as ReactComponent };